// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-banner-style.top-section-gap {
  color: #fff;
  background-color: #181a20;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  min-height: calc(100vh - 58px);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  position: relative;
  max-width: 100%;
  overflow-x: hidden;
  padding-top: 0;
  padding-bottom: 40px;
}

body.light_theme .hero-banner-style.top-section-gap {
  color: #0a0a0a;
  background-color: #ffffff;
}

.hero-banner-style.top-section-gap a {
  text-decoration: none;
  transition: 0.5s all;
}

/* ========== CONTAINER + BOOTSTRAP ========== */

.hero-banner-style.top-section-gap .container {
  max-width: 1480px;
  padding: 0 20px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.hero-banner-style.top-section-gap .row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -12px;
  margin-right: -12px;
}

.hero-banner-style.top-section-gap .row > * {
  padding-left: 12px;
  padding-right: 12px;
  box-sizing: border-box;
}

.hero-banner-style.top-section-gap .align-items-center {
  align-items: center !important;
}

.hero-banner-style.top-section-gap .justify-content-center {
  justify-content: center !important;
}

.hero-banner-style.top-section-gap .text-center {
  text-align: center !important;
}

.hero-banner-style.top-section-gap .col-md-12 {
  flex: 0 0 auto;
  width: 100%;
}

@media (min-width: 992px) {
  .hero-banner-style.top-section-gap .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
}

/* ========== HERO / TITLE ========== */

.hero-banner-style.top-section-gap section.faq_sec {
  padding: 40px 0 0;
}

.hero-banner-style.top-section-gap section.faq_sec .section-title {
  margin-bottom: 20px;
}

.hero-banner-style.top-section-gap .section-title {
  margin-bottom: 60px;
}

.hero-banner-style.top-section-gap .text-gradient,
body.light_theme .hero-banner-style.top-section-gap .text-gradient {
  background: linear-gradient(135deg, #000000 30%, #d1aa67 80%, #d1aa67 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hero-banner-style.top-section-gap .section-title h1 {
  font-family: "Inter", sans-serif;
  font-size: 3.2rem;
  font-weight: 600;
  line-height: 1.25;
  margin: 0;
}

/* ========== CONTENT CARD (plicy_sec) ========== */

.hero-banner-style.top-section-gap .create-item-wrapper.plicy_sec {
  background: #ffffff0f;
  /* border: 1px solid #e2e8f012; */
  border-radius: 16px;
  padding: 40px 32px;
  max-width: 90%;
  margin: 0 auto 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  color: #d9d9d9;
  font-size: 14.5px;
  line-height: 1.75;
}

body.light_theme .hero-banner-style.top-section-gap .create-item-wrapper.plicy_sec {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #475569;
}

.hero-banner-style.top-section-gap .plicy_sec > p:first-of-type {
  margin-bottom: 16px;
}

.hero-banner-style.top-section-gap .plicy_sec p {
  margin: 0 0 16px;
  font-size: 14.5px;
  line-height: 1.75;
}

.hero-banner-style.top-section-gap .plicy_sec h5 {
  font-size: 18px;
  font-weight: 700;
  color: #ededed;
  margin: 24px 0 14px;
}

body.light_theme .hero-banner-style.top-section-gap .plicy_sec h5 {
  color: #0f172a;
}

.hero-banner-style.top-section-gap .plicy_sec strong,
.hero-banner-style.top-section-gap .plicy_sec b {
  color: #ffffff;
  font-weight: 600;
}

body.light_theme .hero-banner-style.top-section-gap .plicy_sec strong,
body.light_theme .hero-banner-style.top-section-gap .plicy_sec b {
  color: #0f172a;
}

.hero-banner-style.top-section-gap .plicy_sec a {
  color: #ce9f4e;
  text-decoration: none;
  font-weight: 500;
  word-break: break-word;
}

.hero-banner-style.top-section-gap .plicy_sec a:hover {
  text-decoration: underline;
}

.hero-banner-style.top-section-gap .plicy_sec ul {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
}

.hero-banner-style.top-section-gap .plicy_sec ul li {
  position: relative;
  padding-left: 24px;
  margin-bottom: 14px;
  font-size: 14.5px;
  line-height: 1.7;
  color: #f7f7f7;
}

body.light_theme .hero-banner-style.top-section-gap .plicy_sec ul li {
  color: #475569;
}

.hero-banner-style.top-section-gap .plicy_sec ul li::before {
  content: "";
  position: absolute;
  left: 4px;
  top: 10px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  /* background: linear-gradient(135deg, #dbb26a, #f1c171); */
}

.hero-banner-style.top-section-gap .plicy_sec center {
  display: block;
  text-align: center;
  margin: 20px 0;
}

/* ========== NUMBERED SECTION BOXES ========== */

.hero-banner-style.top-section-gap .policy-section {
  margin-bottom: 28px;
}

.hero-banner-style.top-section-gap .policy-section h5 {
  margin: 0 0 12px;
}

.hero-banner-style.top-section-gap .policy-box {
  background: #ffffff0a;
  border: 1px solid #ffffff1a;
  border-left: 3px solid #ce9f4e;
  border-radius: 12px;
  padding: 20px 22px;
}

body.light_theme .hero-banner-style.top-section-gap .policy-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-left: 3px solid #ce9f4e;
}

.hero-banner-style.top-section-gap .policy-box > p:last-child,
.hero-banner-style.top-section-gap .policy-box > ul:last-child {
  margin-bottom: 0;
}

.hero-banner-style.top-section-gap .policy-box .policy-note {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px dashed #ffffff1f;
  font-style: italic;
}

body.light_theme .hero-banner-style.top-section-gap .policy-box .policy-note {
  border-top-color: #e2e8f0;
}

/* Lettered / bulleted lists inside a box */

.hero-banner-style.top-section-gap .policy-box .policy-list {
  margin: 0;
}

.hero-banner-style.top-section-gap .policy-box .policy-list li {
  padding-left: 18px;
}

.hero-banner-style.top-section-gap .policy-box .policy-list li:last-child {
  margin-bottom: 0;
}

.hero-banner-style.top-section-gap .policy-box .policy-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 9px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: linear-gradient(135deg, #dbb26a, #f1c171);
}

/* Compact grid used for short lettered items (e.g. section 1) */

.hero-banner-style.top-section-gap .policy-box .policy-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 12px;
  margin: 0;
}

.hero-banner-style.top-section-gap .policy-box .policy-grid li {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #ffffff0d;
  border: 1px solid #ffffff14;
  border-radius: 10px;
  padding: 10px 14px;
  margin: 0;
}

body.light_theme .hero-banner-style.top-section-gap .policy-box .policy-grid li {
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.hero-banner-style.top-section-gap .policy-box .policy-grid li::before {
  display: none;
}

.hero-banner-style.top-section-gap .policy-marker {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 7px;
  background: linear-gradient(135deg, #dbb26a, #f1c171);
  color: #181a20;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

/* Callout line */

.hero-banner-style.top-section-gap .policy-highlight {
  text-align: center;
  background: linear-gradient(135deg, #ce9f4e1f, #ce9f4e08);
  border: 1px solid #ce9f4e40;
  border-radius: 12px;
  padding: 16px 20px;
  margin: 24px 0;
}

/* ========== RESPONSIVE ========== */

@media screen and (max-width: 1700px) {
  .hero-banner-style.top-section-gap .container {
    max-width: 100%;
  }
}

@media screen and (max-width: 1367px) {
  .hero-banner-style.top-section-gap .section-title h1 {
    font-size: 40px;
  }
}

@media screen and (max-width: 1200px) {
  .hero-banner-style.top-section-gap .container {
    max-width: 100%;
  }

  .hero-banner-style.top-section-gap .section-title {
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 991px) {
  .hero-banner-style.top-section-gap section.faq_sec {
    padding: 50px 0 0;
  }

  .hero-banner-style.top-section-gap section.faq_sec .section-title {
    margin-bottom: 0;
  }

  .hero-banner-style.top-section-gap .section-title h1 {
    font-size: 34px;
  }
}

@media screen and (max-width: 767px) {
  .hero-banner-style.top-section-gap .container {
    max-width: 98%;
  }

  .hero-banner-style.top-section-gap section.faq_sec {
    padding: 35px 0 0;
  }

  .hero-banner-style.top-section-gap .section-title h1 {
    font-size: 28px;
  }

  .hero-banner-style.top-section-gap .create-item-wrapper.plicy_sec {
    padding: 24px 18px;
    border-radius: 12px;
    max-width: 100%;
  }

  .hero-banner-style.top-section-gap .plicy_sec h5 {
    font-size: 16px;
  }

  .hero-banner-style.top-section-gap .policy-box {
    padding: 16px 14px;
    border-radius: 10px;
  }

  .hero-banner-style.top-section-gap .policy-box .policy-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/PrivacyDataProtectionPolicy/privacy.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,gDAAgD;;AAEhD;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA,uCAAuC;;AAEvC;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,2EAA2E;EAC3E,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA,mDAAmD;;AAEnD;EACE,qBAAqB;EACrB,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iDAAiD;;AAEjD;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;;AAE3C;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA,gEAAgE;;AAEhE;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,iBAAiB;;AAEjB;EACE,kBAAkB;EAClB,yDAAyD;EACzD,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,qCAAqC;;AAErC;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".hero-banner-style.top-section-gap {\n  color: #fff;\n  background-color: #181a20;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  min-height: calc(100vh - 58px);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n  position: relative;\n  max-width: 100%;\n  overflow-x: hidden;\n  padding-top: 0;\n  padding-bottom: 40px;\n}\n\nbody.light_theme .hero-banner-style.top-section-gap {\n  color: #0a0a0a;\n  background-color: #ffffff;\n}\n\n.hero-banner-style.top-section-gap a {\n  text-decoration: none;\n  transition: 0.5s all;\n}\n\n/* ========== CONTAINER + BOOTSTRAP ========== */\n\n.hero-banner-style.top-section-gap .container {\n  max-width: 1480px;\n  padding: 0 20px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n}\n\n.hero-banner-style.top-section-gap .row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -12px;\n  margin-right: -12px;\n}\n\n.hero-banner-style.top-section-gap .row > * {\n  padding-left: 12px;\n  padding-right: 12px;\n  box-sizing: border-box;\n}\n\n.hero-banner-style.top-section-gap .align-items-center {\n  align-items: center !important;\n}\n\n.hero-banner-style.top-section-gap .justify-content-center {\n  justify-content: center !important;\n}\n\n.hero-banner-style.top-section-gap .text-center {\n  text-align: center !important;\n}\n\n.hero-banner-style.top-section-gap .col-md-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n@media (min-width: 992px) {\n  .hero-banner-style.top-section-gap .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n}\n\n/* ========== HERO / TITLE ========== */\n\n.hero-banner-style.top-section-gap section.faq_sec {\n  padding: 40px 0 0;\n}\n\n.hero-banner-style.top-section-gap section.faq_sec .section-title {\n  margin-bottom: 20px;\n}\n\n.hero-banner-style.top-section-gap .section-title {\n  margin-bottom: 60px;\n}\n\n.hero-banner-style.top-section-gap .text-gradient,\nbody.light_theme .hero-banner-style.top-section-gap .text-gradient {\n  background: linear-gradient(135deg, #000000 30%, #d1aa67 80%, #d1aa67 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.hero-banner-style.top-section-gap .section-title h1 {\n  font-family: \"Inter\", sans-serif;\n  font-size: 3.2rem;\n  font-weight: 600;\n  line-height: 1.25;\n  margin: 0;\n}\n\n/* ========== CONTENT CARD (plicy_sec) ========== */\n\n.hero-banner-style.top-section-gap .create-item-wrapper.plicy_sec {\n  background: #ffffff0f;\n  /* border: 1px solid #e2e8f012; */\n  border-radius: 16px;\n  padding: 40px 32px;\n  max-width: 90%;\n  margin: 0 auto 40px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);\n  color: #d9d9d9;\n  font-size: 14.5px;\n  line-height: 1.75;\n}\n\nbody.light_theme .hero-banner-style.top-section-gap .create-item-wrapper.plicy_sec {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  color: #475569;\n}\n\n.hero-banner-style.top-section-gap .plicy_sec > p:first-of-type {\n  margin-bottom: 16px;\n}\n\n.hero-banner-style.top-section-gap .plicy_sec p {\n  margin: 0 0 16px;\n  font-size: 14.5px;\n  line-height: 1.75;\n}\n\n.hero-banner-style.top-section-gap .plicy_sec h5 {\n  font-size: 18px;\n  font-weight: 700;\n  color: #ededed;\n  margin: 24px 0 14px;\n}\n\nbody.light_theme .hero-banner-style.top-section-gap .plicy_sec h5 {\n  color: #0f172a;\n}\n\n.hero-banner-style.top-section-gap .plicy_sec strong,\n.hero-banner-style.top-section-gap .plicy_sec b {\n  color: #ffffff;\n  font-weight: 600;\n}\n\nbody.light_theme .hero-banner-style.top-section-gap .plicy_sec strong,\nbody.light_theme .hero-banner-style.top-section-gap .plicy_sec b {\n  color: #0f172a;\n}\n\n.hero-banner-style.top-section-gap .plicy_sec a {\n  color: #ce9f4e;\n  text-decoration: none;\n  font-weight: 500;\n  word-break: break-word;\n}\n\n.hero-banner-style.top-section-gap .plicy_sec a:hover {\n  text-decoration: underline;\n}\n\n.hero-banner-style.top-section-gap .plicy_sec ul {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 20px;\n}\n\n.hero-banner-style.top-section-gap .plicy_sec ul li {\n  position: relative;\n  padding-left: 24px;\n  margin-bottom: 14px;\n  font-size: 14.5px;\n  line-height: 1.7;\n  color: #f7f7f7;\n}\n\nbody.light_theme .hero-banner-style.top-section-gap .plicy_sec ul li {\n  color: #475569;\n}\n\n.hero-banner-style.top-section-gap .plicy_sec ul li::before {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  top: 10px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  /* background: linear-gradient(135deg, #dbb26a, #f1c171); */\n}\n\n.hero-banner-style.top-section-gap .plicy_sec center {\n  display: block;\n  text-align: center;\n  margin: 20px 0;\n}\n\n/* ========== NUMBERED SECTION BOXES ========== */\n\n.hero-banner-style.top-section-gap .policy-section {\n  margin-bottom: 28px;\n}\n\n.hero-banner-style.top-section-gap .policy-section h5 {\n  margin: 0 0 12px;\n}\n\n.hero-banner-style.top-section-gap .policy-box {\n  background: #ffffff0a;\n  border: 1px solid #ffffff1a;\n  border-left: 3px solid #ce9f4e;\n  border-radius: 12px;\n  padding: 20px 22px;\n}\n\nbody.light_theme .hero-banner-style.top-section-gap .policy-box {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-left: 3px solid #ce9f4e;\n}\n\n.hero-banner-style.top-section-gap .policy-box > p:last-child,\n.hero-banner-style.top-section-gap .policy-box > ul:last-child {\n  margin-bottom: 0;\n}\n\n.hero-banner-style.top-section-gap .policy-box .policy-note {\n  margin-top: 16px;\n  padding-top: 14px;\n  border-top: 1px dashed #ffffff1f;\n  font-style: italic;\n}\n\nbody.light_theme .hero-banner-style.top-section-gap .policy-box .policy-note {\n  border-top-color: #e2e8f0;\n}\n\n/* Lettered / bulleted lists inside a box */\n\n.hero-banner-style.top-section-gap .policy-box .policy-list {\n  margin: 0;\n}\n\n.hero-banner-style.top-section-gap .policy-box .policy-list li {\n  padding-left: 18px;\n}\n\n.hero-banner-style.top-section-gap .policy-box .policy-list li:last-child {\n  margin-bottom: 0;\n}\n\n.hero-banner-style.top-section-gap .policy-box .policy-list li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 9px;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #dbb26a, #f1c171);\n}\n\n/* Compact grid used for short lettered items (e.g. section 1) */\n\n.hero-banner-style.top-section-gap .policy-box .policy-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));\n  gap: 12px;\n  margin: 0;\n}\n\n.hero-banner-style.top-section-gap .policy-box .policy-grid li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #ffffff0d;\n  border: 1px solid #ffffff14;\n  border-radius: 10px;\n  padding: 10px 14px;\n  margin: 0;\n}\n\nbody.light_theme .hero-banner-style.top-section-gap .policy-box .policy-grid li {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n}\n\n.hero-banner-style.top-section-gap .policy-box .policy-grid li::before {\n  display: none;\n}\n\n.hero-banner-style.top-section-gap .policy-marker {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 7px;\n  background: linear-gradient(135deg, #dbb26a, #f1c171);\n  color: #181a20;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n/* Callout line */\n\n.hero-banner-style.top-section-gap .policy-highlight {\n  text-align: center;\n  background: linear-gradient(135deg, #ce9f4e1f, #ce9f4e08);\n  border: 1px solid #ce9f4e40;\n  border-radius: 12px;\n  padding: 16px 20px;\n  margin: 24px 0;\n}\n\n/* ========== RESPONSIVE ========== */\n\n@media screen and (max-width: 1700px) {\n  .hero-banner-style.top-section-gap .container {\n    max-width: 100%;\n  }\n}\n\n@media screen and (max-width: 1367px) {\n  .hero-banner-style.top-section-gap .section-title h1 {\n    font-size: 40px;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .hero-banner-style.top-section-gap .container {\n    max-width: 100%;\n  }\n\n  .hero-banner-style.top-section-gap .section-title {\n    margin-bottom: 30px;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .hero-banner-style.top-section-gap section.faq_sec {\n    padding: 50px 0 0;\n  }\n\n  .hero-banner-style.top-section-gap section.faq_sec .section-title {\n    margin-bottom: 0;\n  }\n\n  .hero-banner-style.top-section-gap .section-title h1 {\n    font-size: 34px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .hero-banner-style.top-section-gap .container {\n    max-width: 98%;\n  }\n\n  .hero-banner-style.top-section-gap section.faq_sec {\n    padding: 35px 0 0;\n  }\n\n  .hero-banner-style.top-section-gap .section-title h1 {\n    font-size: 28px;\n  }\n\n  .hero-banner-style.top-section-gap .create-item-wrapper.plicy_sec {\n    padding: 24px 18px;\n    border-radius: 12px;\n    max-width: 100%;\n  }\n\n  .hero-banner-style.top-section-gap .plicy_sec h5 {\n    font-size: 16px;\n  }\n\n  .hero-banner-style.top-section-gap .policy-box {\n    padding: 16px 14px;\n    border-radius: 10px;\n  }\n\n  .hero-banner-style.top-section-gap .policy-box .policy-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
